export type NormalizedSiteConfigItem = {
  poste: number;
  indicateurs: Array<number | { id: number; obligatoire?: boolean }>;
  dimensions?: number[];
};

/**
 * Backend `Site.config_json` can be either:
 * - an ARRAY (legacy frontend format): [{ poste, indicateurs: [...] }, ...]
 * - an OBJECT (backend cache format): { "<posteId>": { champs: [{id, obligatoire}], ... }, ... }
 *
 * This normalizes both into the array shape used throughout the UI.
 */
export function normalizeSiteConfigJson(configJson: any): NormalizedSiteConfigItem[] {
  if (!configJson) return [];

  // Legacy / frontend format
  if (Array.isArray(configJson)) {
    return configJson as NormalizedSiteConfigItem[];
  }

  // Backend cache format
  if (typeof configJson === "object") {
    return Object.entries(configJson)
      .map(([posteId, posteConfig]: any): NormalizedSiteConfigItem | null => {
        const poste = Number(posteId);
        if (!Number.isFinite(poste)) return null;

        const champs = Array.isArray(posteConfig?.champs) ? posteConfig.champs : [];

        const indicateurs = champs
          .map((c: any) => {
            const id = typeof c?.id === "number" ? c.id : Number(c?.id);
            if (!Number.isFinite(id)) return null;
            return { id, obligatoire: Boolean(c?.obligatoire) };
          })
          .filter(Boolean) as Array<{ id: number; obligatoire?: boolean }>;

        const dimensions = Array.isArray(posteConfig?.dimensions) ? posteConfig.dimensions : [];

        return { poste, indicateurs, dimensions };
      })
      .filter(Boolean) as NormalizedSiteConfigItem[];
  }

  return [];
}
